export const SITE_URL = 'https://www.getfriday.com';

// One canonical per page: /About, /about/ and /about all resolve to https://www.getfriday.com/about
export const getCanonicalUrl = (pathname = '/') => {
  const path = pathname.replace(/\/+$/, '').toLowerCase() || '/';
  return `${SITE_URL}${path}`;
};

// react-helmet appends a page's description / keywords / canonical at the end of <head>,
// below every injected <style>. Keep them right under <title> instead, on every page and
// after every route change, so they are easy to find (and land there in prerendered HTML).
const SEO_TAGS = 'meta[name="description"], meta[name="keywords"], link[rel="canonical"]';

export const keepSeoTagsAfterTitle = () => {
  const head = document.head;
  const place = () => {
    let anchor = head.querySelector('title');
    if (!anchor) return;
    head.querySelectorAll(SEO_TAGS).forEach((el) => {
      if (anchor.nextElementSibling !== el) anchor.after(el);
      anchor = el;
    });
  };
  place();
  // Re-runs whenever Helmet swaps tags; once everything is in place it makes no moves, so it settles.
  new MutationObserver(place).observe(head, { childList: true });
};
